import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { history } from 'nallian-shared-ui/lib/config/history';
import { Modal } from 'nallian-shared-ui/lib/components';
import { Table, Params, Actions } from 'nallian-table-builder-ui';
import { INFINITE_SCROLL, COMMUNITY_ROLE_RESOURCE, COMMUNITY_DETAIL_TABS } from '../../constants';
import apiRoutes from '../../../../app/api/routes';
import Country from '../../../app/components/Country';

const CommunityRoleOrganisationsOverview = ({ open }) => {
  const { t } = useTranslation();
  const { id, actionId } = useParams();

  const handleClose = useCallback(() => {
    history.push(`/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.ROLES}`);
  }, [id]);

  return (
    <Modal open={open} onClose={handleClose} closeIcon>
      <Modal.Header>
        {t('organisationsForRole')} {actionId}
      </Modal.Header>
      <Modal.Content>
        <Table
          url={apiRoutes.communityRoles2(id, actionId)}
          infiniteScroll={INFINITE_SCROLL}
          resource={COMMUNITY_ROLE_RESOURCE}
          rootTableProperty="communityMembers"
          noResultsMessage={t('noOrganisationsFound')}
          pageSize={100}
          noUserSettings
        >
          <Actions.Link
            iconbutton
            width="2.5rem"
            icon="eye"
            align="center"
            url="/organisations/:id"
          />
          <Params.String name="name" label="organisationName" width="16rem" minWidth="16rem" grow />
          <Params.String name="city" width="16rem" minWidth="16rem" grow />
          <Params.Custom content={Country} name="country" width="16rem" minWidth="16rem" grow />
        </Table>
      </Modal.Content>
    </Modal>
  );
};

CommunityRoleOrganisationsOverview.propTypes = { open: PropTypes.bool };
CommunityRoleOrganisationsOverview.defaultProps = { open: false };

export default CommunityRoleOrganisationsOverview;
